<!--
================================================
Un composant affichant une progress barre pour symboliser la progression d'un projet

Url d'accès :
http://localhost:8080/fr/adobe/projects/project-photoshop/details
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>

  <progress class="ProjectProgressionbar progress"
            v-bind:class="[{'darkMode':themeToDisplay=='dark'},colorByPercent(project)]"
            v-bind:value="calculateProjectPercent(project)" max="100">
  </progress>


  <!--    https://www.npmjs.com/package/v-click-outside-->
  <!--    <div v-click-outside="onClickOutside"></div> -->
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import SentryMixin from "@/mixins/SentryMixin.js";
import GlobalErrorNotification from "@/mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "@/mixins/InterceptorMixin.js";
import TrackingMixin from "@/mixins/TrackingMixin";
import ProjectMixin from "@/mixins/ProjectMixin";


export default {
  name: 'ProjectProgressionbar', //utile dans vue dev tool
  mixins: [
    GlobalErrorNotification,
    SentryMixin,
    InterceptorMixin,
    TrackingMixin,
    ProjectMixin
  ],
  // components: {},

  props: {
    /** pour typage et validation voir :
     *  https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
     *  https://fr.vuejs.org/v2/guide/components-props.html#Validation-des-props
     **/
    //
    project: {
      type: Object, // l'objet project
      required: true,
      //   default: false,
      //  ou si l'on veut que défaut soit une  fonction ex : pour retourner un objet vide
      default: () => ({})
    },
  },

  data: function () {
    return {
      locale: this.$route.params.locale
      // pour les composants où l'user est identifié ///////////////////////
      // organizationSlug: this.$route.params.organization
      // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug (ou dispo dans this.$auth.getUserSlug())
      // componentIsReady : false, // indique quand le composant est prêt à être affiché
      // =================================================================
    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay
    }),

  },

  methods: {

  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {

  },
  beforeDestroy() {
    /**
     * Lorsqu'un event semble être déclenché plusieurs fois (alors qu'il ne devrait pas) il peut-être nécéssaire de supprimer son listener...
     Cette solution est inspirée de
     - https://stackoverflow.com/a/61049328/666416
     - https://charlietheprogrammer.com/duplicate-vue-event-listeners-and-how-i-solved-them
     **/
    // this.$root.$off('timerecord_suggestions_required', () => {
    //   console.debug('suppression du event listener timerecord_suggestions_required')
    // })

  },
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/css/globalVar.scss";
/*@import "../assets/css/bulmaResponsiveDep.scss";*/

.ProjectProgressionbar {

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////
  $progressBgColor: #ddd;

  margin: auto;

  &.under50 { // couleur : vert
    &::-webkit-progress-value {
      background-color: $brandPrimary;
    }

    &::-moz-progress-bar {
      background: $brandPrimary;
    }

    color: $brandPrimary; // ie 10
  }


  &.under70 { // couleur vert jusqu'à 50% orange à 70%
    $gradient: linear-gradient(90deg, $brandPrimary 80%, $brandOrange 100%);

    &::-webkit-progress-value {
      background: $gradient
    }

    &::-moz-progress-bar {
      background: $gradient;
    }

    color: $gradient; // ie 10
  }

  &.under100 { // couleur :  vert jusqu'à 50% orange à 70% rouge à 90%
    $gradient: linear-gradient(90deg, $brandPrimary 50%, $brandOrange 80%);

    &::-webkit-progress-value {
      background: $gradient
    }

    &::-moz-progress-bar {
      background: $gradient;
    }

    color: $gradient; // ie 10
  }

  &.over100 {
    $gradient: linear-gradient(90deg, $brandOrange 5%, $brandRed 90%);

    &::-webkit-progress-value {
      background: $gradient;
    }

    &::-moz-progress-bar {
      background: $gradient;
    }

    color: $gradient; // ie 10
  }


  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {

    // couleur de fond de la progress bar
    &::-webkit-progress-bar {
      background-color: lighten($darkBg, 7%) !important;
    }

    // chromium
    background-color: lighten($darkBg, 7%) !important; // firefox


  }

}
</style>
